import { Validator } from '@vista-digital/validator';
export const cdnStandardAssetOptionsValidatorSchema = {
    width: Validator.optional(Validator.number({ min: 1 })),
    height: Validator.optional(Validator.number({ min: 1 }))
};
export const cdnStandardAssetOptionsValidator = Validator.object(cdnStandardAssetOptionsValidatorSchema);
//# sourceMappingURL=cdn-asset-options.js.map